import {TtLiveActivityEntry} from '../../interfaces/time-tracking/tt-live-activity-entry';


export class TtLiveActivityEntryFactory {
  /**
   *
   * @param liveActivityEntry
   */
  public static fromObject(liveActivityEntry: any): TtLiveActivityEntry {
    return new class implements TtLiveActivityEntry {
      employeeId: number = liveActivityEntry.employee_id;
      customerId: number = liveActivityEntry.customer_id;
      opOperatingPlanItemId: number = liveActivityEntry.operating_plan_item_id;
      timeFrom: string = liveActivityEntry.time_from;
      ttActivityTypeId: number = liveActivityEntry.tt_activity_type_id;

      // ------------------------------------------------------------------------------------------------
      id: number = liveActivityEntry.id;
      uuid: string = liveActivityEntry.uuid;
      modified: string = liveActivityEntry.modified;
      created: string = liveActivityEntry.created;
      deleted: 0 | 1 = 0;
    };
  }

  /**
   *
   * @param liveActivityEntries
   */
  public static fromArray(liveActivityEntries: any[]): TtLiveActivityEntry[] {
    return liveActivityEntries.map(TtLiveActivityEntryFactory.fromObject);
  }

  /**
   *
   * @param liveActivityEntry
   */
  public static new(liveActivityEntry: Partial<TtLiveActivityEntry> = {}): TtLiveActivityEntry {
    const _liveActivityEntry = new class implements TtLiveActivityEntry {
      employeeId: number = null;
      customerId: number = null;
      opOperatingPlanItemId: number = null;
      timeFrom: string = null;
      // ------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
      deleted: 0 | 1 = 0;
      ttActivityTypeId: number = null;
    };

    return {..._liveActivityEntry, ...liveActivityEntry};
  }

  /**
   *
   * @param ttLiveActivityEntry
   */
  public static toRemote(ttLiveActivityEntry: Partial<TtLiveActivityEntry>): any {
    return {
      uuid: ttLiveActivityEntry.uuid,
      employee_id: ttLiveActivityEntry.employeeId,
      customer_id: ttLiveActivityEntry.customerId,
      operating_plan_item_id: ttLiveActivityEntry.opOperatingPlanItemId,
      time_from: ttLiveActivityEntry.timeFrom,
      modified: ttLiveActivityEntry.modified,
      created: ttLiveActivityEntry.created,
      tt_activity_type_id: ttLiveActivityEntry.ttActivityTypeId,
    };
  }
}
